import { FC, useRef } from "react";
import { ListMenuItem } from "./ListMenuItem";

import styles from "./listMenu.module.scss";
import { useClickOutsideRef } from "Hooks";

type TListMenuProps = {
    onClickOutsideCallback?: () => void,
    children: (JSX.Element | null)[]
}

export const ListMenu: FC<TListMenuProps> = ({children, onClickOutsideCallback}: TListMenuProps) => {

    // Ref
    const ellipseMenuRef = useRef<HTMLDivElement>(null);
    
    // Handle clicking outside menu

    const onClickOutsideMenu = () => {
        if(onClickOutsideCallback) {
            onClickOutsideCallback();
        }
    }

    useClickOutsideRef(ellipseMenuRef, onClickOutsideMenu);

    return (
        <div ref={ellipseMenuRef} className={styles.listMenu}>
            {
                children.map((child, index) => {
                    if(!child) return null;

                    return (
                        <ListMenuItem key={"li" + index} name={child.props.title} icon={child.props.icon} onClick={child.props.onClick} />
                    );
                })
            }
        </div>
    );
}